module.exports = __webpack_public_path__ + "static/assets/8ce26a259215de2c699199157d439b2f.png";